export const SCHEDULE_HEADER = "Schedule";
export const SCHEDULE_SUBHEADER =
  "Find and add some classes to keep track daily.";
